module.exports = __webpack_public_path__ + "static/media/1.e97aedb5.jpg";